import { Component } from 'react';

import PropTypes from 'prop-types';

import { Box } from '@mui/material';

import FilterSelectComponent from './FilterSelectComponent';

class MultiFilterSelectComponent extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      filterValues: {},
    };
    this.onFilterChange = this.onFilterChange.bind(this);
  }

  onFilterChange(filter, value) {
    const { filterValues } = this.state;
    const { onChange } = this.props;
    const { key, setOnChange, listParamsFormatter } = filter;

    const newFilterValues = { ...filterValues };
    newFilterValues[key] = value;

    this.setState({ filterValues: newFilterValues });
    let newParams = { [key]: value?.value ?? value };

    if (setOnChange) {
      newParams = { ...newParams, ...setOnChange };
    }
    if (typeof listParamsFormatter === 'function') {
      newParams = listParamsFormatter(newParams);
    }
    onChange(newParams);
  }

  render() {
    const { filterValues } = this.state;
    const { filters, dateRange, isLoading } = this.props;

    if (!filters?.length) return null;

    return filters && filters.length ? (
      <Box display="flex" flexWrap="wrap" width="100%" gap="1rem" mb="0.5rem">
        {filters.map((filter) => (
          <FilterSelectComponent
            key={filter.key}
            filter={filter}
            filterValues={filterValues}
            onChange={(value) => this.onFilterChange(filter, value)}
            isLoading={isLoading}
          />
        ))}
        {dateRange}
      </Box>
    ) : null;
  }
}

MultiFilterSelectComponent.defaultProps = {
  dateRange: null,
};

MultiFilterSelectComponent.propTypes = {
  filters: PropTypes.instanceOf(Array).isRequired,
  onChange: PropTypes.func.isRequired,
  dateRange: PropTypes.instanceOf(Object),
  isLoading: PropTypes.bool,
};

export default MultiFilterSelectComponent;
